import { ReactNode } from "react";

interface props {
  children: ReactNode;
}
const FormContainer = ({ children }: props) => {
  return (
    <div className="w-full sm:min-h-screen sm:h-full md:h-screen bg-violet-500 flex justify-center items-center">
      <div className="sm:w-full md:w-[450px] sm:py-10 sm:min-h-screen sm:h-full md:min-h-max md:h-max bg-white sm:rounded-none md:rounded-md sm:p-5 md:p-10 flex items-center justify-center flex-col gap-5">
        {children}
      </div>
    </div>
  );
};

export default FormContainer;
